import axios from 'axios'
export default {
    state: {
        orders: {},
        order_filters: {
            name: '',
            status: -1,
            limit: 5,
            offset: 0,
            count_orders: 0
        },
        order: {
            order: {
                company_inn: '',
                company_name: '',
                company_region: '',
                company_adres: '',
                company_okved: '',
                company_count_employers: '',
            },
            user: {},
            quiz: {
                in_project: '', 
                products: '', 
                problem: '', 
                groups: '', 
                learn_center: '', 
                work_group: '', 
                leader_position: '', 
            },
            is_order_show: false
        },
        criterias: {}
    },
    getters: {
        orders: (state) => state.orders,
        order: (state) => state.order,
        order_filters: (state) => state.order_filters,
        criterias: (state) => state.criterias,
    },
    mutations: {
        SET_ORDERS(state, playload) {
            state.orders = playload
        },
        SET_ORDER_FILTER(state, playload) {
            state.order_filters[playload.field] = playload.value
        },
        SET_ORDER_DATA(state, playload) {
            state.order = playload
        },
        CLOSE_ORDER(state) {
            state.order = {
                order: {},
                user: {},
                quiz: {},
                is_order_show: false
            }
        },
        SHOW_ORDER(state) {
            state.order.is_order_show = true
        },
        UPDATE_FIELD_ORDER_VALUE(state, playload) {
            state.order.order[playload.field] = playload.value
        },
        UPDATE_FIELD_QUIZ_VALUE(state, playload) {
            state.order.quiz[playload.field] = playload.value
        },
        SET_CRITERIAS(state, playload) {
            state.criterias = playload
        }
    },
    actions: {
        Close__Order({commit, dispatch}) {
            commit('CLOSE_ORDER')
            dispatch('GET_ORDERS')
        },
        GET_ORDERS({commit, state}) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            axios.post(process.env.VUE_APP_API_URL + '/api/orders/orders', {
                name: state.order_filters.name,
                status: state.order_filters.status,
                offset: state.order_filters.offset *  state.order_filters.limit,
                limit: state.order_filters.limit,

            })
                .then(response => {
                    commit('SET_ORDERS', response.data.data)
                    commit('SET_ORDER_FILTER', {field: 'count_orders', value: response.data.count_records})
                })
                .catch(error => {
                    commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                });
        },
        GET__Order({commit, state}, id) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            axios.get(process.env.VUE_APP_API_URL + '/api/orders/order/' + id,)
                .then(response => {
                    commit('SET_ORDER_DATA', response.data.data)
                    commit('SHOW_ORDER')
                })
                .catch(error => {
                    commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                });
        },
        UPDATE__Order({commit, dispatch, state}) {
            commit('SET_PRELOADER_BUTTON', true)
            setTimeout(function() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                axios.patch(process.env.VUE_APP_API_URL + '/api/orders/order/data/' + state.order.order.id, {
                    company_inn: state.order.order.company_inn,
                    company_name: state.order.order.company_name,
                    company_region: state.order.order.company_region,
                    company_adres: state.order.order.company_adres,
                    company_okved: state.order.order.company_okved,
                    company_count_employers: state.order.order.company_count_employers,
                })
                    .then(response => {
                        dispatch('GET__Order', state.order.order.id)
                        dispatch('GET_ORDERS')
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => {
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                    });
            }, 2000)
        },
        UPDATE__Quiz({commit, dispatch, state}) {
            commit('SET_PRELOADER_BUTTON', true)
            setTimeout(function() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                axios.patch(process.env.VUE_APP_API_URL + '/api/orders/order/quiz/' + state.order.order.id, {
                    in_project: state.order.quiz.in_project,
                    products: state.order.quiz.products,
                    problem: state.order.quiz.problem,
                    groups: state.order.quiz.groups,
                    learn_center: state.order.quiz.learn_center,
                    work_group: state.order.quiz.work_group,
                    leader_position: state.order.quiz.leader_position,
                })
                    .then(response => {
                        dispatch('GET__Order', state.order.order.id)
                        //dispatch('GET_ORDERS')
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => {
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                    });
            }, 2000)
        },
        async UPLOAD__FileOrder({commit, dispatch, state}, data) {
            commit('SET_PRELOADER_BUTTON', true)
            setTimeout(function() {
                let formData = new FormData();
                formData.append('file', data.file)
                formData.append('field', data.field)
                formData.append('id', state.order.order.id)
                //formData.append('size', data.size)
                //formData.append('type', data.type)

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                axios.post(`${process.env.VUE_APP_API_URL}/api/orders/order/file`, formData)
                    .then(Response => {
                        dispatch('GET__Order', state.order.order.id)
                        //dispatch('GET_ORDERS')
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => { 
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                     })
            }, 2000)
        },
        async CLEAR__FileOrder({commit, dispatch, state}, data) {
            commit('SET_PRELOADER_BUTTON', true)
            setTimeout(function() {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
                axios.post(`${process.env.VUE_APP_API_URL}/api/orders/order/fileclear`, {
                    id: state.order.order.id,
                    field: data
                })
                    .then(Response => {
                        dispatch('GET__Order', state.order.order.id)
                        //dispatch('GET_ORDERS')
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => { 
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                     })
            }, 2000)
        },
        async GET__Questions({commit, dispatch, state}) {
            commit('SET_PRELOADER_BUTTON', true)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            await axios.get(`${process.env.VUE_APP_API_URL}/api/orders/questions/`+state.order.order.id)
                .then(Response => {
                        //dispatch('GET_ORDERS')
                        commit('SET_CRITERIAS', Response.data.data)
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => { 
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                     })
        },
        async SET__ExpertAnswer({commit, dispatch, state}, data) {
            commit('SET_PRELOADER_BUTTON', true)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            await axios.post(`${process.env.VUE_APP_API_URL}/api/orders/questions`, {
                criteria_id: data.criteria_id,
                question_id: data.question_id,
                answer_id: data.answer_id,
                answer_mark: data.answer_mark,
                company_id: state.order.order.id
            })
                .then(Response => {
                        dispatch('GET__Questions')
                        //commit('SET_CRITERIAS', Response.data.data)
                        commit('SET_PRELOADER_BUTTON', false)
                    })
                    .catch(error => { 
                        commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                     })
        }
    }
}